// Third party
import { createSlice } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// Components
import { IRootState } from './type';
import { reducers } from './reducers';
import { TManagedUsers } from '../../types';
import { PERSIST_KEYS, STORE_SLICES } from '../../utils';

const initialState: IRootState = {
  managed_users: [] as TManagedUsers[],
};

export const slice = createSlice({
  name: STORE_SLICES.MANAGED_USERS_DATA,
  initialState,
  reducers,
});

const managedUsersDataActions = slice.actions;

const managedUsersDataPersistConfig = {
  key: PERSIST_KEYS.MANAGED_USERS_DATA,
  storage,
};

export { managedUsersDataActions, initialState };
export default persistReducer(managedUsersDataPersistConfig, slice.reducer);
